import { render, staticRenderFns } from "./m-assinar.vue?vue&type=template&id=06cf4f16&"
import script from "./m-assinar.vue?vue&type=script&lang=js&"
export * from "./m-assinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports